import React from 'react';
import { Link } from 'react-router-dom';
import LazyHeroBg from '../components/LazyHeroBg';
import { publicImageUrl } from '../utils/publicAsset';
import './LandingPage.css';

const LandingPage = () => {
  const img = (name) => publicImageUrl(name);

  return (
    <div className="landing-page">
      <LazyHeroBg src={img('landingbg.png')} className="landing-page__bg" fetchPriority="high" />
      <div className="landing-page__overlay" aria-hidden="true" />

      <div className="landing-page__content">
        <header className="landing-page__header">
          <h1 className="landing-page__title">WELCOME TO 1ST LUXURY</h1>
          <div className="landing-page__title-divider" aria-hidden="true">
            <span className="landing-page__title-divider-blue" />
            <span className="landing-page__title-divider-gold" />
          </div>
          <p className="landing-page__subtitle">Choose your division to continue</p>
        </header>

        <div className="landing-page__cards">
          <article className="landing-card landing-card--logistics">
            <div className="landing-card__logo">
              <img src={img('updatedlogo.png')} alt="1st Luxury Logistics" />
            </div>
            <p className="landing-card__brand">1ST LUXURY</p>
            <h2 className="landing-card__division">LOGISTICS</h2>
            <div className="landing-card__divider landing-card__divider--blue" />
            <p className="landing-card__desc">Global logistics solutions you can rely on.</p>
            <Link to="/logistics" className="landing-card__btn landing-card__btn--blue">
              ENTER
            </Link>
          </article>

          <article className="landing-card landing-card--marketing">
            <div className="landing-card__logo">
              <img src={img('marketinglogo.png')} alt="1st Luxury Marketing" />
            </div>
            <p className="landing-card__brand">1ST LUXURY</p>
            <h2 className="landing-card__division">MARKETING</h2>
            <div className="landing-card__divider landing-card__divider--gold" />
            <p className="landing-card__desc">Creative marketing strategies that drive results.</p>
            <Link to="/marketing" className="landing-card__btn landing-card__btn--gold">
              ENTER
            </Link>
          </article>
        </div>

        <footer className="landing-page__footer">
          <div className="landing-page__footer-divider" aria-hidden="true">
            <span className="landing-page__footer-divider-blue" />
            <span className="landing-page__footer-divider-gold" />
          </div>
          <p className="landing-page__copyright">
            &copy; 2026 1ST LUXURY. ALL RIGHTS RESERVED.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default LandingPage;
